import React, { ReactElement } from "react";
import { LayoutProps } from "../../containers/Interfaces";
import Navbar from "../navbar/Navbar";
import { Box } from "@chakra-ui/react";
import { useUIContext } from "context/UIContext";

const Layout: React.FC<LayoutProps> = ({
  children,
  scrollable,
}: LayoutProps): ReactElement => {
  const { isNavbarCollapsed } = useUIContext();

  return (
    <Box overflow="hidden" height="100vh">
      {/* Sidebar*/}
      <Navbar />
      <Box
        ml={{ base: 0, md: isNavbarCollapsed ? "60px" : "240px" }}
        mt={{ base: "60px", md: 0 }}
        transition="margin-left 0.3s ease"
        overflowY={scrollable ? "auto" : "hidden"}
        height="100vh"
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;